import { createPatientTrackingCsvImportConfig, PatientTrackerPage } from '@jarvis/platform-ui';
import { patientTrackingImportApi } from '../../api/patientTrackingImport';
import { showErrorToast, showSuccessToast } from '../../notifications/toast';

const trackerCsvImport = createPatientTrackingCsvImportConfig(
  {
    title: 'CE Patient Tracking',
    intro:
      'Import Covered Entities and Patients before tracker rows. Each row needs a pharmacy name or GUID in the pharmacy column.',
    templateUrl: patientTrackingImportApi.tracker.templateUrl,
    templateFileName: patientTrackingImportApi.tracker.templateFileName,
    importCsv: patientTrackingImportApi.tracker.importCsv,
    downloadTemplate: patientTrackingImportApi.tracker.downloadTemplate
  },
  { showSuccess: showSuccessToast, showError: showErrorToast }
);

export function CEPatientTrackingPage() {
  return <PatientTrackerPage csvImport={trackerCsvImport} stateStorageKey="webopsui:patient-tracker-grid" />;
}
